<template>
  <div class="home">
    <b-container fluid>
      <b-row align-h="between">
        <h1>通信設計支援ツール</h1>
        <button @click="signOut" class="btn btn-outline-secondary">SignOut</button>
      </b-row>
      <b-row align-h="start">
        <h3 text-align="left">システム仕様</h3>
      </b-row>
      <b-row align-h="between">
        <b-col>
          <b-form-group
            label="システム仕様Ver"
            label-for="sys_spec_ver"
            label-cols="4"
          >
            <b-form-input
              id="sys_spec_ver"
              v-model="selectedVersion"
              :state="versionValidator"
            ></b-form-input>
            <b-form-invalid-feedback
              class="text-left">
              有効なバージョンを指定してください
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col align-v="end">
          <b-row align-h="start">
            <b-button
              @click="pushDisplayButton"
              variant="outline-secondary"
              class="sysspec_buttons"
              :disabled="!versionValidator"
            >表示</b-button>
            <b-button
              @click="copySystemSpec"
              variant="outline-secondary"
              class="sysspec_buttons"
              :disabled="!versionValidator"
            >コピー</b-button>
            <b-button
              @click="newSystemSpec"
              variant="outline-secondary"
              class="sysspec_buttons"
              :disabled="!versionValidator"
            >新規</b-button>
            <b-button
              @click="confirmDelete = !confirmDelete"
              variant="outline-danger"
              class="sysspec_buttons"
              :disabled="!versionValidator"
            >削除</b-button>
          </b-row>
        </b-col>
      </b-row>
      <b-row align-h="start">
        <h3 text-align="left">システム機能ツリー</h3>
      </b-row>
      <b-row align-h="start">
        <b-container fluid class="container_sizing overflow-auto">
          <TreeView :version="treeVersion"/>
        </b-container>
      </b-row>
      <b-row>
        <b-col align-h="start">
          <h3>設計支援機能</h3>
          <router-link to="/progress/property">プロパティ一覧作成</router-link><br>
          <router-link to="/progress/attribute">属性一覧作成</router-link><br>
          <router-link to="/progress/command">共通通信コマンド自動作成</router-link><br>
          <router-link to="/progress/traffic">トラフィック計算</router-link><br>
        </b-col>
        <b-col align-h="start">
          <h3>設計支援機能</h3>
          <router-link to="/difinition/function_class">システム機能分類</router-link><br>
          <router-link to="/difinition/frame_type">フレーム種別</router-link><br>
          <router-link to="/difinition/communication_trigger">通信トリガ</router-link><br>
          <router-link to="/difinition/communication_path">通信経路設定</router-link><br>
          <router-link to="/difinition/system_config">システム構成</router-link><br>
          <router-link to="/difinition/group_config">グループ構成</router-link><br>
          <router-link to="/difinition/traffic_config">設定ファイル</router-link>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      v-model="confirmDelete"
      hide-footer
    >
      <b-row align-h="center">
        <p>本当に削除してもよろしいですか。</p>
      </b-row>
      <b-row align-h="around">
        <button
          class="btn btn-outline-danger"
          @click="deleteSystemSpec"
        >はい</button>
        <button
          class="btn btn-outline-secondary"
          @click="confirmDelete = !confirmDelete"
        >いいえ</button>
      </b-row>
    </b-modal>

    <b-modal
      v-model="confirmPropertyDesign"
      hide-header
      hide-footer
    >
    <b-row>
      <p>プロパティ一覧を作成しますか</p>
    </b-row>
    <b-row>
      <button
        class="btn btn-outline-info"
        @click="transferPropertyDesign"
      >新規に作成</button>
      <button
        class="btn btn-outline-secondary"
        @click="transferCreatedProperties"
      >作成済を参照</button>
      <button
        class="btn btn-outline-secondary"
        @click="confirmPropertyDesign = !confirmPropertyDesign"
      >キャンセル</button>
    </b-row>
    </b-modal>
    <b-modal
      v-model="showHolder"
      no-close-on-backdrop
      no-close-on-esc
      no-enforce-focus
      hide-footer
      hide-header
      centered
      :visible="true"
      body-class="modal_body"
    >
      <b-row align-h="center">
        <b-spinner
          style="width: 20rem; height: 20rem;"
          variant="primary"
        ></b-spinner>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { API, graphqlOperation, Auth } from 'aws-amplify'
import TreeView from '../common_parts/TreeView'
import { mapState } from 'vuex'
export default {
  name: 'mainpage',
  components: {
    TreeView
  },
  data () {
    return {
      selectedVersion: '',
      treeVersion: '',
      confirmDelete: false,
      showHolder: false,
      confirmPropertyDesign: false
    }
  },
  methods: {
    async pushDisplayButton () {
      await this.displaySystemSpec()
      this.resetCompletedJob()
    },
    async displaySystemSpec () {
      if (this.selectedVersion === '') {
        this.makeToast('失敗', 'バージョンが指定されていません', 'danger')
      }
      const specification = await API.graphql(graphqlOperation(`
        query listSysSpec{
          listSystemSpecifications(version: "${this.selectedVersion}"){
            items {
              no
              name
            }
          }
        }
      `))
      if (specification.data.listSystemSpecifications.items.length === 0) {
        this.makeToast('失敗', '指定したバージョンが存在しません', 'danger')
      }
      this.treeVersion = this.selectedVersion
      this.makeToast('成功', `${this.selectedVersion}を表示しました。`, 'info')
      this.$store.commit('updateVersion', this.selectedVersion)
    },
    resetCompletedJob () {
      this.$store.commit('updateCompletedJob', '')
    },
    async displayLatestSystemSpec () {
      if (this.selectedVersion === '') {
        this.makeToast('最新', '最新のバージョンを表示します', 'info')
      }
      const specification = await API.graphql(graphqlOperation(`
        query getLatestVersion {
          getLatestVersion {
            no
            name
            version
          }
        }
      `))
      if (specification.data.getLatestVersion.version === undefined) {
        this.makeToast('失敗', '最新のバージョンが存在しません。', 'danger')
        return
      }
      const latestVersion = specification.data.getLatestVersion.version
      this.selectedVersion = latestVersion
      this.treeVersion = latestVersion
      this.$store.commit('updateVersion', latestVersion)
    },
    async copySystemSpec () {
      try {
        const copy = await API.graphql(graphqlOperation(`
          mutation copyVerstion{
            copyVersion(version: "${this.selectedVersion}"){
              no
              version
            }
          }`)
        )
        this.$log.debug(copy)
        const beforeVersion = this.selectedVersion
        this.selectedVersion = copy.data.copyVersion.version
        this.treeVersion = copy.data.copyVersion.version
        this.$store.commit('updateVersion', this.selectedVersion)
        this.makeToast('成功', `バージョン${beforeVersion}をコピーして、バージョン${copy.data.copyVersion.version}を作成しました`, 'info')
      } catch (error) {
        this.$log.debug(error)
        this.makeToast('失敗', `バージョン${this.selectedVersion}のコピーに失敗しました`, 'danger')
      }
    },
    async newSystemSpec () {
      const specification = await API.graphql(graphqlOperation(`
        query listSysSpec{
          listSystemSpecifications(version: "${this.selectedVersion}"){
            items {
              version
            }
          }
        }
      `))
      if (specification.data.listSystemSpecifications.items.length > 0) {
        this.makeToast('失敗', '指定したバージョンはすでに存在します。', 'danger')
        return
      }
      this.$store.commit('updateVersion', this.selectedVersion)
      this.$router.push('/system_specification')
    },
    async deleteSystemSpec () {
      try {
        await API.graphql(graphqlOperation(`
          mutation deleteSysSpec{
            deleteSystemSpecification(input:{
              no: 1
              version: "${this.selectedVersion}"
            }){
              no
              name
            }
          }
        `))
        this.$router.go()
        this.makeToast('成功', '削除に成功しました', 'info')
      } catch (error) {
        this.makeToast('失敗', '削除に失敗しました', 'danger')
      }
    },
    transferPropertyDesign () {
      this.$router.push('/progress/properties')
    },
    transferCreatedProperties () {
      this.$router.push('/progress/properties')
    },
    async signOut () {
      try {
        await Auth.signOut()
        this.$router.push('/auth')
      } catch (e) {
        this.makeToast('失敗', 'サインアウトできませんでした', 'info')
      }
    }
  },
  mounted () {
    if (this.version === '') {
      this.displayLatestSystemSpec()
    } else {
      this.selectedVersion = this.version
      this.displaySystemSpec()
    }
  },
  computed: {
    versionValidator () {
      return !!this.selectedVersion.match(/^([1-9]\d*|0)(\.\d+)$/)
    },
    ...mapState(['version'])
  }
}
</script>
<style>
  .container_sizing {
    height: 400px;
    border: 1px solid #cccccc;
  }
  .sysspec_buttons {
    margin-top: 0.8rem;
    margin-right: 0.5rem;
  }
  .modal_body {
    opacity: 1;
  }
</style>
